<template>
  <div id="bubbleHeader" class="pb-2">
    <div style="height: 40vh">
      <img class="bubbles" src="../assets/img/bubbles.svg" alt="bubbles">
      <div class="pr-4 pt-4 text-right text-white position-absolute" style="z-index: 121; top: 0; right: 0;">
        <img style="width:auto; height: 90px;" src="../assets/img/logo-login.svg" alt="Logo Kawaa">
        <h3 class="mb-0">Kawaa</h3>
        <p class="font-weight-light">Le Jeu</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'bubbleHeader',
  computed: {}
}
</script>

<style>
  .bubbles {
    width: 100%;
    position: relative;
    z-index: -1;
    /* top: -85px; */
    top: -70px;
    background-size: cover;
    object-fit: cover;
  }
</style>



// WEBPACK FOOTER //
// src/components/HeaderComponent.vue